module.exports = __webpack_public_path__ + "static/media/meme.91f81733.png";